import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props =>
    props.selected ? props.theme.white : props.theme.primary};
`;

const ChannelsDropdownIcon = ({ selected }) => {
  if (window.innerWidth > 1800) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22.089"
        height="21.777"
        viewBox="0 0 22.089 21.777"
      >
        <G
          selected={selected}
          transform="translate(1 1)"
          fill="none"
          strokeMiterlimit="10"
          strokeWidth="2"
        >
          <circle cx="4.075" cy="4.075" r="4.075" />
          <circle
            cx="4.075"
            cy="4.075"
            r="4.075"
            transform="translate(11.94)"
          />
          <circle
            cx="4.075"
            cy="4.075"
            r="4.075"
            transform="translate(0 11.627)"
          />
          <circle
            cx="4.075"
            cy="4.075"
            r="4.075"
            transform="translate(11.94 11.627)"
          />
          <line y2="3.478" transform="translate(4.075 8.149)" />
          <line x2="3.79" transform="translate(8.149 15.702)" />
          <line y1="6.049" x2="6.049" transform="translate(7.007 6.827)" />
        </G>
      </svg>
    );
  } else
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.263"
        height="16.026"
        viewBox="0 0 16.263 16.026"
      >
        <G
          selected={selected}
          transform="translate(-1004.237 -366.454)"
          fill="none"
          strokeMiterlimit="10"
        >
          <circle
            cx="3.096"
            cy="3.096"
            r="3.096"
            transform="translate(1004.737 366.954)"
          />
          <circle
            cx="3.096"
            cy="3.096"
            r="3.096"
            transform="translate(1013.809 366.954)"
          />
          <circle
            cx="3.096"
            cy="3.096"
            r="3.096"
            transform="translate(1004.737 375.788)"
          />
          <circle
            cx="3.096"
            cy="3.096"
            r="3.096"
            transform="translate(1013.809 375.788)"
          />
          <line y2="2.643" transform="translate(1007.833 373.146)" />
          <line x2="2.88" transform="translate(1010.929 378.884)" />
          <line y1="4.596" x2="4.596" transform="translate(1010.061 372.141)" />
        </G>
      </svg>
    );
};

export default ChannelsDropdownIcon;
